<script>
import DefaultLayout from '@/layouts/DefaultLayout.vue'
export default DefaultLayout
</script>
